import React, { useMemo } from 'react';
import { IconButton, Badge } from '@mui/material';
import ChatBubbleIcon from '@mui/icons-material/ChatBubble';
import { useChatList } from './ChatListContext';
import { useUnreadCountsContext } from 'components/UnreadCountsContext';

const ChatIconButton: React.FC = () => {
  const { toggleChatList, isChatListVisible } = useChatList();
  const { unreadCounts } = useUnreadCountsContext();

  // Calculate total unread count from all conversations
  const totalUnreadCount = useMemo(() => {
    return Object.values(unreadCounts).reduce((sum, count) => sum + count, 0);
  }, [unreadCounts]);

  return (
    <IconButton
      onClick={toggleChatList}
      className="mx-2"
      sx={{
        color: '#1877f2',
        backgroundColor: isChatListVisible ? '#E6EEFF' : '#F5F7FF',
        marginRight: '12px',
        '&:hover': {
          backgroundColor: '#E0E7FF',
        },
        borderRadius: '50%',
        width: 36,
        height: 36,
        transition: 'background-color 0.15s ease-in-out',
        boxShadow: 'none',
        border: '1px solid #E0E7FF',
      }}
      title="Messages"
    >
      <Badge 
        badgeContent={totalUnreadCount} 
        color="error" 
        invisible={totalUnreadCount === 0}
        sx={{
          '& .MuiBadge-badge': {
            fontSize: '0.65rem',
            fontWeight: 'bold',
            minWidth: '16px',
            height: '16px',
            padding: 0,
            boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
            border: '2px solid #F5F7FF',
            top: 4,
            right: 4,
          },
        }}
      >
        <ChatBubbleIcon sx={{ fontSize: 20 }} />
      </Badge>
    </IconButton>
  );
};

export default ChatIconButton;

